
function Tutorial() {
  return (
    <div>

      <section className="bg-dark text-white py-5">
        <div className="text-center mb-5">
          <h1 className="display-4">Tutorial para adaptador universal para captura de imágenes del fondo del ojo</h1>
          <br />
          <p className="lead">Aprende a utilizar nuestro adaptador universal para capturar imágenes del fondo del ojo de manera efectiva.</p>
          <br />
          <img 
            src={`${process.env.PUBLIC_URL}/Images/Logo1.png`} 
            alt="VitaVision AI-ris"
            className="img-1"
          />
          <h2 className="text-center mb-4">VitaVision AI-RIS</h2>
        </div>

      </section>
    
            <div className="text-center">

              <br></br>
              <img 
                src="./Images/Tutorial.jpeg" 
                alt="Tutorial"
                className="img-fluid rounded shadow" 
              />

              
            </div>
          
    </div>
  );
}

export default Tutorial;